export default __webpack_public_path__ + "static/media/1459.55a1cc3c.jpg";